import React, { useEffect, useMemo, useState, useCallback } from "react";
import styles from "./ApplicantsPage.module.scss";
import ApplicantTable from "../../components/ApplicantTable/ApplicantTable";
import { API } from "../../service/Interceptor";
import { debounce } from "../../utils/utils";
import { useParams } from "react-router-dom";
import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import FilterIconSVG from "../../components/SVGComponents/FilterIconSVG";
import SearchSVG from "../../components/SVGComponents/SearchSVG";
import { useDispatch, useSelector } from "react-redux";
import { getProjectbyID } from "../../reducer/projectsSlice";
import InfiniteScroll from "react-infinite-scroll-component";
import TableSkeleton from "components/common/Table/TableSkeleton";

const perPageData = 7;

const ApplicantsPage = () => {
  const [page, setPage] = useState(1);
  const [displayApplicants, setDisplayApplicants] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [status, setStatus] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const { project } = useSelector((state) => state.projects);

  const removeDuplicateEntries = (arr) => {
    let filteredArr = [];
    let idSet = new Set();
    for (let i = 0; i < arr.length; i++) {
      if (!idSet.has(arr[i]?.userId)) {
        idSet.add(arr[i]?.userId);
        filteredArr.push(arr[i]);
      }
    }
    return filteredArr;
  };

  const fetchAllApplicants = useCallback(async () => {
    try {
      const params = {
        pageNo: page,
        perPage: perPageData,
        status,
        searchTerm: searchText,
      };
      const res = await API.get(`api/jobs/${projectId}/applicants`, { params });
      const results = res?.data?.data?.results || [];

      let filteredResults = removeDuplicateEntries([
        ...displayApplicants,
        ...results,
      ]);
      if (filteredResults.length < perPageData) {
        setHasMore(false);
      } else {
        setPage((prev) => prev + 1);
      }
      // setDisplayApplicants((prev) => [...prev, ...results]);
      setDisplayApplicants(filteredResults);
    } catch (error) {
      console.error(error);
    }
  }, [page, projectId, status, searchText]);

  useEffect(() => {
    fetchAllApplicants();
  }, [searchText, status]);

  useEffect(() => {
    dispatch(getProjectbyID(projectId));
  }, [dispatch, projectId]);

  const handleStatusChange = (stats, idx) => {
    setPage(1);
    setHasMore(true);
    setDisplayApplicants([]);
    setStatus(stats);
    setActiveIndex(idx);
  };

  const optimizedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchText(value);
        setPage(1);
        setHasMore(true);
        setDisplayApplicants([]);
      }, 500),
    []
  );

  const handleInputChange = (e) => {
    optimizedSearch(e.target.value);
  };

  const skeletonColumns = [
    { width: 400 },
    { width: 400 },
    { width: 400 },
    { width: 400 },
    { width: 400 },
    { width: 400 },
  ];

  return (
    <section className={styles.applicantsPage}>
      <div className={styles.applicantsHeading}>
        {activeIndex === 0 && <p>{project?.jobTitle}</p>}
        {activeIndex === 1 && <p>View All Shortlisted Applicants</p>}
        {activeIndex === 2 && <p>View All Rejected Applicants</p>}
      </div>

      <section className={styles.parentSection}>
        <div className={styles.appNavSection}>
          <div className={styles.leftbar}>
            <ul>
              <li
                onClick={() => handleStatusChange("", 0)}
                className={activeIndex === 0 ? styles.active : ""}
              >
                All Applicants
              </li>
              <li
                onClick={() => handleStatusChange("SHORTLIST", 1)}
                className={activeIndex === 1 ? styles.active : ""}
              >
                Shortlisted
              </li>
              <li
                onClick={() => handleStatusChange("REJECTED", 2)}
                className={activeIndex === 2 ? styles.active : ""}
              >
                Rejected
              </li>
            </ul>
          </div>
          <div className={styles.rightbar}>
            {/* <div className={styles.filterIcon}>
              <FilterIconSVG />
              <p>Filter</p>
            </div> */}
            <div className={styles.searchWrapper}>
              <input
                type="search"
                placeholder="Search"
                onChange={handleInputChange}
              />
              <div className={styles.searchIcon}>
                <SearchSVG />
              </div>
              {/* <div className={styles.filterIcon}>
                <FilterIconSVG />
              </div> */}
            </div>
          </div>
        </div>

        <div className={styles.listingPage}>
          <InfiniteScroll
            dataLength={displayApplicants.length}
            next={fetchAllApplicants}
            hasMore={hasMore}
            loader={
              <div className={styles.loader}>
                {/* <SpinnerLoader /> */}
                <TableSkeleton columns={skeletonColumns} height={40} rows={6} />
              </div>
            }
            // endMessage={<p style={{ textAlign: "center" }}>No more applicants</p>}
          >
            <ApplicantTable
              applicants={displayApplicants}
              projectId={projectId}
              setDisplayApplicants={setDisplayApplicants}
            />
          </InfiniteScroll>
        </div>
      </section>
    </section>
  );
};

export default ApplicantsPage;
